import { createSerializer, parseAsString } from 'nuqs'

import { PRODUCT_TOUR_QUERY_PARAM } from './tourIds'

/**
 * Shared nuqs parser for the product-tour query param (`?productTour=<id>`) — the
 * single definition used by both the reader (`useQueryState` in
 * `useNetworkMembersWelcomeTour`) and the URL serializer below.
 */
export const productTourParser = parseAsString

export const productTourSearchParams = {
  [PRODUCT_TOUR_QUERY_PARAM]: productTourParser,
}

/**
 * Build a URL with the product-tour param correctly appended, e.g.
 * `serializeProductTourUrl('/n/acme/members', { productTour: 'welcome_v1' })`
 * → `/n/acme/members?productTour=welcome_v1`. Handles the `?`/`&` separators.
 */
export const serializeProductTourUrl = createSerializer(productTourSearchParams)
